import { NBY, Shoe } from '@nike/nike-design-system-icons';
import classnames from 'classnames';
import { RANKING_RULE_TARGET_TYPES } from 'constants/index';
import { JapaneseYen, Shapes } from 'lucide-react';
import { useMemo } from 'react';

export default function TargetItem({
  data,
}: {
  data: RankingRuleTargetBoostItem | RankingRuleTargetBuryItem;
}) {
  const clx = classnames(
    'tw-border-solid tw-flex tw-items-center tw-justify-between tw-rounded-full tw-border tw-text-sm tw-py-1 tw-px-2 tw-text-nowrap tw-min-w-[130px]',
    {
      'tw-text-green-700 tw-border-green-700 tw-bg-green-200/50':
        data.type === RANKING_RULE_TARGET_TYPES.STYLE_COLOR,
      'tw-text-neutral-800 tw-border-neutral-400 tw-bg-neutral-100':
        data.type === RANKING_RULE_TARGET_TYPES.STYLE_CODE,
      'tw-text-zinc-800 tw-border-zinc-400 tw-bg-white':
        data.type === RANKING_RULE_TARGET_TYPES.PBID,
      'tw-text-blue-800 tw-border-blue-400 tw-bg-blue-100':
        data.type === RANKING_RULE_TARGET_TYPES.TAXONOMY,
      'tw-text-purple-800 tw-border-purple-400 tw-bg-purple-100':
        data.type === RANKING_RULE_TARGET_TYPES.PRICE,
    },
  );

  const text = useMemo(() => {
    if (data.type === RANKING_RULE_TARGET_TYPES.PRICE) {
      const { multiValue, value, relation } = data;
      if (relation === 'range') {
        return `${multiValue?.[0] || '?'} < price < ${multiValue?.[1] || '?'}`;
      } else if (relation === 'lt') {
        return `price < ${value}`;
      } else if (relation === 'gt') {
        return `price > ${value}`;
      }
    }
    return data.label || data.value;
  }, [data]);

  const icon = useMemo(() => {
    if (data.type === RANKING_RULE_TARGET_TYPES.PRICE) {
      return <JapaneseYen size={16} className='tw-m-1' />;
    }
    if (data.type === RANKING_RULE_TARGET_TYPES.TAXONOMY) {
      return <Shapes size={16} className='tw-m-1' />;
    }
    if (
      data.type === RANKING_RULE_TARGET_TYPES.STYLE_COLOR ||
      data.type === RANKING_RULE_TARGET_TYPES.STYLE_CODE
    ) {
      return <Shoe size='s' />;
    }
    if (data.type === RANKING_RULE_TARGET_TYPES.PBID) {
      return <NBY size='s' title='by PBID' />;
    }
  }, [data.type]);

  return (
    <div className={clx}>
      {icon}
      <div className='tw-px-0.5'>{text}</div>
    </div>
  );
}
